var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"fb-login-button mr-4 v-btn v-btn--is-elevated v-btn--has-bg v-size--default",attrs:{"type":"button"},on:{"click":_vm.logInWithFacebook}},[_vm._v(" CONTINUAR CON FACEBOOK ")])
}
var staticRenderFns = []

export { render, staticRenderFns }